import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=4fbc570e&"
import script from "../../../services/layout/company-header.js?vue&type=script&lang=js&"
export * from "../../../services/layout/company-header.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports